import { EntityType } from 'proto/generated/inspector_gadget';
import { ContentType } from 'proto/generated/tintin_content_policy';

export const ASSET_EXISTENCE_CHECK_ENTITIES_TO_ASSETS: Partial<Record<EntityType, ContentType[]>> = {
  [EntityType.ENTITY_TYPE_PLAYLIST]: [
    ContentType.CONTENT_TYPE_PLAYLIST_IMAGE,
    ContentType.CONTENT_TYPE_PLAYLIST_TITLE,
    ContentType.CONTENT_TYPE_PLAYLIST_DESCRIPTION,
  ],
  [EntityType.ENTITY_TYPE_USER]: [ContentType.CONTENT_TYPE_USER_IMAGE],
  [EntityType.ENTITY_TYPE_TRACK]: [ContentType.CONTENT_TYPE_NOW_PLAYING, ContentType.CONTENT_TYPE_MUSIC_VIDEO],
  [EntityType.ENTITY_TYPE_ARTIST]: [ContentType.CONTENT_TYPE_ARTIST_MERCHANDISE],
};
